import React from 'react';
import { useNavigate } from 'react-router-dom';
import UserMenu from './UserMenu';
import './UserDashboard.css';

const UserDashboard: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="user-dashboard">
      <UserMenu />

      <div className="dashboard-container">
        <div className="placeholder-content">
          <div className="placeholder-icon">🚧</div>
          <h1>User Dashboard</h1>
          <p>Currently, only admin functionalities are exposed.</p>
          <p className="sub-text">More features for users coming soon!</p>

          <button className="btn btn-primary" onClick={() => navigate('/')}>
            Go to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserDashboard;
